import { render, staticRenderFns } from "./Authenticator.vue?vue&type=template&id=4aaf7c49&scoped=true&"
import script from "./Authenticator.vue?vue&type=script&lang=ts&"
export * from "./Authenticator.vue?vue&type=script&lang=ts&"
import style0 from "./Authenticator.vue?vue&type=style&index=0&id=4aaf7c49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf7c49",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VContainer,VRow})
